import { Card, Divider, Typography } from '@mui/material';
import { Box, Stack, useTheme } from '@mui/system';

import { Dimens } from '~themes';

interface MultiSelectBarProps {
	label: string;
	actions?: React.ReactElement[];
}

const MultiSelectBar = ({ label = '', actions = [] }: MultiSelectBarProps) => {
	const { palette } = useTheme();
	return (
		<Box
			sx={{
				position: 'absolute',
				bottom: Dimens.spacingLg,
				left: '0',
				right: '0',
				display: 'flex',
				flexDirection: 'column',
				justifyItems: 'center',
				alignItems: 'center',
			}}
		>
			<Card
				elevation={1}
				sx={{
					display: 'flex',
					pl: Dimens.spacing3xl,
					pr: Dimens.spacingLg,
					borderRadius: Dimens.radiusFull,
					backgroundColor: palette.bgTertiary.main,
					outline: '1px solid',
					outlineColor: palette.borderSecondary.main,
				}}
			>
				<Stack direction='row' sx={{ textAlign: 'center' }}>
					<Typography variant='labelXs' color={palette.textTertiary.main} alignContent='center'>
						{label}
					</Typography>
					<Divider
						orientation='vertical'
						sx={{
							height: 'auto',
							marginLeft: Dimens.spacingXl,
							marginRight: Dimens.spacingSm,
							marginTop: Dimens.spacingSm,
							marginBottom: Dimens.spacingSm,
							borderColor: palette.borderSecondary.main,
						}}
					/>
					{actions}
				</Stack>
			</Card>
		</Box>
	);
};

export default MultiSelectBar;
